import { SelectItem } from "primeng/api/selectitem";

export class ReportRefereneces {

    dateRangeDropdown: SelectItem[] = [];
    portOutActDropdown: SelectItem[] = [];
    portInActDropdown: SelectItem[] = [];

    constructor() {

        this.dateRangeDropdown = [
            { label: "Date Range", value: "dateRange"},
            { label: "Last 24 Hours", value: "last24Hours"},
            { label: "Last 7 Days", value: "last7Days"},
            { label: "Last 30 Days", value: "last30Days"},
            { label: "Last 90 Days", value: "last90Days"}
        ]

        this.portOutActDropdown = [
            { label: "TN Ports", value: "deleteMe", disabled: true},
            { label: "Inter-SPID Port Out from Previous Port", value: "Inter-SPID Port Out from Previous Port", styleClass: ''},
            { label: "Inter-SPID Port Out from NPB", value: "Inter-SPID Port Out from NPB"},
            { label: "Inter-SPID Port Out from Code", value: "Inter-SPID Port Out from Code"},
            { label: "TN Port Deletes", value: "deleteMe", disabled: true},
            { label: "Delete Port - TN snapped back to NPB with different SPID", value: "Delete Port - TN snapped back to NPB with different SPID"},
            { label: "Delete Port - TN snapped back to NPB with same SPID", value: "Delete Port - TN snapped back to NPB with same SPID"},
            { label: "Delete Port - TN snapped back to Code with different SPID", value: "Delete Port - TN snapped back to Code with different SPID"},
            { label: "Delete Port - TN snapped back to Code with same SPID", value: "Delete Port - TN snapped back to Code with same SPID"}
        ]

        this.portInActDropdown = [
            { label: "TN Ports", value: "deleteMe", disabled: true},
            { label: "Inter-SPID Port from Previous Port", value: "Inter-SPID Port from Previous Port", styleClass: ''},
            { label: "Inter-SPID Port from NPB", value: "Inter-SPID Port from NPB"},
            { label: "Inter-SPID Port from Code", value: "Inter-SPID Port from Code"},
            { label: "Intra-SPID Port from NPB", value: "Intra-SPID Port from NPB"},
            { label: "Intra-SPID Port from Code", value: "Intra-SPID Port from Code"},
            { label: "TN Port Deletes", value: "deleteMe", disabled: true},
            { label: "Delete Port - TN with different SPID snapped back to NPB", value: "Delete Port - TN with different SPID snapped back to NPB"},
            { label: "Delete Port - TN snapped same SPID snapped back to NPB", value: "Delete Port - TN snapped same SPID snapped back to NPB"},
            { label: "Delete Port - TN with different SPID snapped back to Code", value: "Delete Port - TN with different SPID snapped back to Code"},
            { label: "Delete Port - TN snapped same SPID snapped back to Code", value: "Delete Port - TN snapped same SPID snapped back to Code"},
        ]

    }
}